import Reveal from "@/components/Reveal";
import OfferBanner from "@/components/OfferBanner";

export default function PromoBanner() {
  return (
    <section className="px-[2.4cqw] pt-[2cqw]" data-testid="promo-banner">
      <Reveal>
        <OfferBanner home />
      </Reveal>
    </section>
  );
}
